import { axiosCms } from 'Axios.js';
import { authToken } from '../utility';
import * as actionTypes from './actionTypes';

const createAdminStart = () => ({ type: actionTypes.CREATE_ADMIN_START });
const createAdminEnd = () => ({ type: actionTypes.CREATE_ADMIN_END });
const fetchAdminsStart = () => ({ type: actionTypes.FETCH_ADMINS_START });
const fetchAdminsEnd = admins => ({ type: actionTypes.FETCH_ADMINS_END, admins });
const updateAdminState = (data, id) => ({ type: actionTypes.UPDATE_ADMIN_STATE, data, id });
const deleteAdminsStart = () => ({ type: actionTypes.DELETE_ADMIN_START });
const deleteAdminsEnd = () => ({ type: actionTypes.DELETE_ADMIN_END });

export const checkEmail = email => {
  axiosCms.defaults.headers.common['Authorization'] = window.localStorage.getItem('token');
  return axiosCms.post('/admins/email', { email: email });
};

export const createAdmin = values => {
  return dispatch => {
    dispatch(createAdminStart());

    axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());
    return axiosCms
      .post('/admins', values)
      .then(dispatch(createAdminEnd()))
      .catch(err => {
        console.error(`#createAdmin`, err);
        return Promise.reject(err);
      });
  };
};

export const fetchAdmins = () => {
  return dispatch => {
    dispatch(fetchAdminsStart());

    axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());
    return axiosCms
      .get('/admins')
      .then(response => {
        const { data } = response;
        return dispatch(fetchAdminsEnd(data.admins));
      })
      .catch(err => {
        console.error(`#fetchAdmin`, err);
        return Promise.reject(err);
      });
  };
};

export const updateAdmin = (data, id) => dispatch => {
  dispatch(updateAdminState(data, id));

  axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());

  return axiosCms
    .patch('/admins/' + id, data)
    .then(res => {
      dispatch(fetchAdmins());
      return 'updated';
    })
    .catch(err => {
      console.error(`#updateAdmin error: `, err);
      return Promise.reject(err);
    });
};

export const deleteAdmin = id => {
  return dispatch => {
    dispatch(deleteAdminsStart());

    axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());
    return axiosCms
      .delete('/admins/' + id)
      .then(dispatch(deleteAdminsEnd()))
      .catch(err => {
        console.error(`#deleteAdmin`, err);
        return Promise.reject(err);
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/admins.js